// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box } from 'grommet'

import {
  ModalDialog,
  Typography,
  ModalHeader,
  ButtonGroup,
  CCSForm,
  FormInput
} from '../../../../components'

const EditSCIMIntegrationModal = ({
  setShowEditModal,
  handleEditScimIntegration,
  scimName
}) => {
  const { t } = useTranslation(['common', 'iam'])
  const [name, setName] = useState(scimName)
  const closeModal = () => {
    setShowEditModal(false)
  }

  return (
    <ModalDialog
      overflow="hidden"
      position="right"
      height="100%"
      header={
        <ModalHeader
          title={
            <Box direction="column">
              <Typography
                testId="edit-external-scim-integration-modal-title"
                type="text"
                weight="bold"
                size="xlarge"
              >
                {t('iam:external_scim_integrations.edit_scim_title')}
              </Typography>
            </Box>
          }
        />
      }
      content={
        <Box margin={{ top: 'xsmall' }} width="medium">
          <CCSForm
            onSubmit={() => handleEditScimIntegration(name)}
            onReset={() => {
              setShowEditModal(false)
            }}
            errorMessage=""
            testId="edit-scim-integration-form"
            validate="blur"
          >
            <Box direction="column" justify="between">
              <FormInput
                testId="name-form-input"
                inputType="text"
                name="name"
                label={t('iam:igc_users.add_user_add_to_group_name_column')}
                labelHelper={
                  <Typography type="text" size="xsmall">
                    {t('iam:external_scim_integrations.edit_scim_desc')}
                  </Typography>
                }
                required
                value={name}
                margin={{ top: 'small', bottom: 'large' }}
                onChange={(event) => {
                  setName(event.target.value)
                }}
              />

              <ButtonGroup
                buttonList={[
                  {
                    id: 1,
                    label: t(
                      'iam:external_scim_integrations.update_scim_integration_btn'
                    ),
                    primary: true,
                    testId: 'save-btn',
                    type: 'submit'
                  },
                  {
                    id: 2,
                    label: t('common:cancel'),
                    default: true,
                    testId: 'cancel-button',
                    type: 'reset'
                  }
                ]}
                justifyGroup="start"
                testId="edit-scim-integration-buttons"
              />
            </Box>
          </CCSForm>
        </Box>
      }
      onClose={closeModal}
      onClickOutside={closeModal}
      testId="edit-scim-integration-modal-dialog"
    />
  )
}

EditSCIMIntegrationModal.propTypes = {
  setShowEditModal: PropTypes.func.isRequired,
  handleEditScimIntegration: PropTypes.func.isRequired,
  scimName: PropTypes.object.isRequired
}

export { EditSCIMIntegrationModal }
